import type { Money } from '@urbanrats/contracts';

/**
 * Amounts per currency. Different currencies are never added together; a total across currencies
 * would need a labelled conversion policy, which the portal does not have.
 */
export class PerCurrency {
  private readonly m = new Map<string, { scale: number; v: bigint }>();

  add(x: Money | { amountAtomic: string; currency: string; scale: number }, sign: 1n | -1n = 1n): this {
    const cur = this.m.get(x.currency);
    if (cur && cur.scale !== x.scale) throw new Error(`scale mismatch for ${x.currency}`);
    this.m.set(x.currency, { scale: x.scale, v: (cur?.v ?? 0n) + sign * BigInt(x.amountAtomic) });
    return this;
  }

  ensure(currency: string, scale: number): this {
    if (!this.m.has(currency)) this.m.set(currency, { scale, v: 0n });
    return this;
  }

  get(currency: string): bigint {
    return this.m.get(currency)?.v ?? 0n;
  }

  entries(): { currency: string; scale: number; atomic: bigint }[] {
    return [...this.m.entries()].map(([currency, x]) => ({ currency, scale: x.scale, atomic: x.v })).sort((a, b) => a.currency.localeCompare(b.currency));
  }
}
